require('datatables.net');
require('datatables.net-bs5');
require('../assets/js/NumberInput');
require('../assets/js/Filter');
require('../assets/js/ShortList');
require('../assets/js/Alerts');
require('../assets/js/BusinessContactForm');
require('../assets/js/ChangeBusinessForSale');
require('../assets/js/ChangeBusinessWanted');
require('../assets/js/BusinessForSaleListing');
require('../assets/js/BusinessWantedListing');